<template>
  <v-card color="mt-3 pa-2 primary darken-1">
    <v-row class="pa-6" align="center">
      <v-icon class="mr-1" size="16">restore</v-icon>
      <h1 style="font-family: Roboto;font-style: normal;font-weight: normal;font-size: 12px;line-height: 16px;">{{this.lastUpdate()}}</h1>
    </v-row>
    <v-card-title class="mb-0">
      <chart-header
        :authorize="authorize"
        @fullscreenChart="fullscreenChart"
        @printChart="printChart"
        @exportChart="exportChart($event)"
        @exportCSV="exportCSV"
        @exportXLS="exportXLS"
      >
        <template v-slot:title>
          Dados meteorológicos
        </template>
      </chart-header>
    </v-card-title>
    <v-card-text >
      <h3 class="subtitle-1 white--text">Selecione o período:</h3>
      <v-tabs class="hidden-sm-and-down secondary--text text--lighten-1" v-model="tab" active-class="secondary lighten-1 primary--text text--darken-1" background-color="primary darken-1" slider-color="secondary lighten-1">
        <v-tab class="tab-item-title" v-for="(item, index) in items" :key="index">{{item.text}}</v-tab>
      </v-tabs>
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="hidden-md-and-up tab-item-title transparent"
            outlined
            v-bind="attrs"
            v-on="on"
          >
            {{items[tab].text}}
            <v-icon >
              mdi-menu-down
            </v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, index) in items" :key="index" @click="changeTabItem(index)">
            {{item.text}}
          </v-list-item>
        </v-list>
      </v-menu>

      <v-tabs-items v-model="tab" class="primary darken-1" touchless>
        <v-tab-item class="px-0">
          <v-card flat color="primary darken-1">
            <v-card-text class="px-0 text-center">
              <today-meteorological-chart
                :hourly="hourly"
                :location="location"
                @chartRenderComplete="chartRenderComplete($event)"
              ></today-meteorological-chart>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat color="primary darken-1">
            <v-card-text class="px-0 text-center">
              <tomorrow-meteorological-chart
                :hourly="hourly"
                :location="location"
                @chartRenderComplete="chartRenderComplete($event)"
              ></tomorrow-meteorological-chart>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat color="primary darken-1">
            <v-card-text class="px-0 text-center">
              <diary-meteorological-chart
                :location="location"
                @chartRenderComplete="chartRenderComplete($event)"
              ></diary-meteorological-chart>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import DiaryMeteorologicalChart from "./DiaryMeteorologicalChart";
import TomorrowMeteorologicalChart from "./TomorrowMeteorologicalChart";
import TodayMeteorologicalChart from "./TodayMeteorologicalChart";
import moment from "moment";
import Highcharts from "highcharts";
import Exporting from 'highcharts/modules/export-data';
import ChartHeader from "../ChartHeader";
import { dailyMeteorologicalChartAuthorization, todayMeteorologicalChartAuthorization, tomorrowMeteorologicalChartAuthorization } from '../../../helpers/chart_export_authorization';
Exporting(Highcharts);
export default {
  components: {ChartHeader, TodayMeteorologicalChart, TomorrowMeteorologicalChart, DiaryMeteorologicalChart},
  props:['location'],
  name: "MeteorologicalChart",
  data: () => ({
    tab: 0,
    items:[
      {
        text: 'Hoje',
      },
      {
        text: 'Amanhã',
      },
      {
        text: '15 dias',
      }
    ],
    hourly: undefined,
    update: undefined,
    chartRendered: undefined,
    authorize: undefined,
  }),
  watch: {
    tab(){
      if(this.tab === 0){
        this.authorize = todayMeteorologicalChartAuthorization
      } else if(this.tab === 1){
        this.authorize = tomorrowMeteorologicalChartAuthorization
      } else if(this.tab === 2){
        this.authorize = dailyMeteorologicalChartAuthorization
      }
    },
    location(){
      if(this.location){
        this.initialize()
      }
    }
  },
  mounted() {
    if(this.tab === 0){
      this.authorize = todayMeteorologicalChartAuthorization
    } else if(this.tab === 1){
      this.authorize = tomorrowMeteorologicalChartAuthorization
    } else if(this.tab === 2){
      this.authorize = dailyMeteorologicalChartAuthorization
    }
    this.initialize()
  },
  methods:{
    async initialize(){
      await this.$store.dispatch('loadMeteorologicalForecast', {
        type: 'hourly',
        source: '22',
        location_id: this.location.locationid
      })
      let hourly = await this.$store.getters.meteorologicalForecast
      this.update = hourly[0].updated
      this.hourly = hourly[0].value
    },
    changeTabItem(tabIndex){
      this.tab = tabIndex;
    },
    chartRenderComplete(chart){
      this.chartRendered = chart;
    },
    exportChart(typeFile){
      this.chartRendered.exportChart({type: typeFile});
    },
    exportCSV(){
      this.chartRendered.downloadCSV();
    },
    exportXLS(){
      this.chartRendered.downloadXLS()
    },
    fullscreenChart(){
      const fullscreenControl = new Highcharts.Fullscreen(this.chartRendered);
      fullscreenControl.open();
    },
    printChart(){
      this.chartRendered.print();
    },
    lastUpdate(){
      if(this.update){
        let date = moment(this.update, 'YYYY-MM-DDTHH:mm:ssZ').tz("America/Sao_Paulo").format( "DD/MM/YYYY [às] HH:mm")
        return `Atualizado em ${date}.`;
      }
      return '';
    },
  }
}
</script>

<style scoped>
.tab-item-title{
  color: var(--v-secondary-lighten1) !important;
  border: 1px solid var(--v-secondary-lighten1) !important;
  text-transform: none;
}
</style>
